import React from 'react';
import styled from 'styled-components';

const VisualDiv = styled.div`

`;

export function Visual() {
    return (
        <VisualDiv className={"visual visual--has-image"}>
            <div className="visual__container">
                <div className="ppi_row">
                    <div className="ppi_col-md-11 ppi_col-md-offset-1 ppi_col-lg-10 ppi_col-lg-offset-2">
                        <div className="ppi_row">
                            <div className="ppi_col-md-6">
                                <h1>Energiebilanzrechner</h1>
                                <p>
                                    Alle biologischen Abläufe im Körper benötigen Energie. Energie nimmt der Mensch über die Nahrung zu sich. Der Energiebedarf eines Menschen ist individuell verschieden und von vielen Faktoren abhängig.
                                    Hier können Sie Ihren individuellen Energiebedarf grob errechnen. Zudem finden Sie Beispiele für die Kalorienverbrennung.
                                </p>
                            </div>
                            <div className="ppi_col-md-6">
                                <div className="visual__image image image--box">
                                    <img src="https://www.zuckerverbaende.de/wp-content/uploads/sites/3/2021/06/Bewegung_1_Titel.png" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </VisualDiv>
    );
}
